export const COUNTRY_CODES = ['+852', '+886', '+65', '+63', '+62', '+81', '+82'];
